import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useAccountSettings } from "./useAccountSettings";
import React from "react";

const AccountSettingsPage = () => {
  const {
    selectedTab,
    updateSelectedTab,
    tableTabs,
    isLoadingAccount,
    updateAccountMappingMutation,
    filterAccountBySubAccountType,
    findAccountMapping,
    handleAccountMappingSubmit,
  } = useAccountSettings();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Account Settings"
      description="Manage your account settings, including VAT preferences and store configurations"
    >
      <secondaryComponents.LoaderHelper classNames="mt-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${styles["accounting"]} ${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Accounting Settings</h4>
            <p>
              Configure your chart of accounts and default mappings for seamless
              financial management.
            </p>

            <div className="mt-3">
              <div className={`${globalStyles.rowNavigations} mb-4`}>
                {tableTabs?.map((item, index) => {
                  const key = item?.key;
                  return (
                    <React.Fragment key={index}>
                      <secondaryComponents.NavigateWithPermission
                        permissionParentKey="Accounting"
                        showOnLocalSetup={item?.showOnLocalSetup}
                      >
                        {/* eslint-disable-next-line */}
                        <a
                          className={`${globalStyles.rowNavigations__item} ${
                            key === selectedTab ? globalStyles.active : ""
                          }`}
                          onClick={() => {
                            updateSelectedTab(key);
                          }}
                        >
                          {item?.label}
                        </a>
                      </secondaryComponents.NavigateWithPermission>
                    </React.Fragment>
                  );
                })}
              </div>
              <div
                className={`${globalStyles.tableWrapper} ${styles["accounting__tabs"]}`}
              >
                <secondaryComponents.LoaderHelper
                  isLoading={isLoadingAccount}
                  classNames={"pt-5"}
                >
                  {selectedTab === "sales_tab" && (
                    <secondaryComponents.SalesAccountSettings
                      filterAccountBySubAccountType={
                        filterAccountBySubAccountType
                      }
                      findAccountMapping={findAccountMapping}
                      updateAccountMappingMutation={
                        updateAccountMappingMutation
                      }
                      handleAccountMappingSubmit={handleAccountMappingSubmit}
                    />
                  )}
                  {selectedTab === "expenses_tab" && (
                    <secondaryComponents.ExpensesAccountSettings
                      filterAccountBySubAccountType={
                        filterAccountBySubAccountType
                      }
                      findAccountMapping={findAccountMapping}
                      updateAccountMappingMutation={
                        updateAccountMappingMutation
                      }
                      handleAccountMappingSubmit={handleAccountMappingSubmit}
                    />
                  )}
                  {selectedTab === "inventory_tab" && (
                    <secondaryComponents.InventoryAccountSettings
                      filterAccountBySubAccountType={
                        filterAccountBySubAccountType
                      }
                      findAccountMapping={findAccountMapping}
                      updateAccountMappingMutation={
                        updateAccountMappingMutation
                      }
                      handleAccountMappingSubmit={handleAccountMappingSubmit}
                    />
                  )}
                  {selectedTab === "taxes_tab" && (
                    <secondaryComponents.TaxesAccountSettings
                      filterAccountBySubAccountType={
                        filterAccountBySubAccountType
                      }
                      findAccountMapping={findAccountMapping}
                      updateAccountMappingMutation={
                        updateAccountMappingMutation
                      }
                      handleAccountMappingSubmit={handleAccountMappingSubmit}
                    />
                  )}
                  {selectedTab === "equity_tab" && (
                    <secondaryComponents.EquityAccountSettings
                      filterAccountBySubAccountType={
                        filterAccountBySubAccountType
                      }
                      findAccountMapping={findAccountMapping}
                      updateAccountMappingMutation={
                        updateAccountMappingMutation
                      }
                      handleAccountMappingSubmit={handleAccountMappingSubmit}
                    />
                  )}
                </secondaryComponents.LoaderHelper>
              </div>
            </div>
          </div>
        </motion.div>
      </secondaryComponents.LoaderHelper>
    </secondaryComponents.MetaSetter>
  );
};

export default AccountSettingsPage;
